import { appConfig } from '@/config/appConfig';

export const filterParams = {
    page: { key: 'fleet_sizes_current_page', apiKey: appConfig.filter.defaultPageQueryName, defaultValue: null },
    perPage: { key: 'fleet_sizes_per_page', apiKey: appConfig.filter.defaultPerPageQueryName, defaultValue: null },
    sortBy: { key: 'sort_fleet_sizes_by', apiKey: appConfig.filter.defaultSortByQueryName, defaultValue: null },
    orderBy: { key: 'order_fleet_sizes_by', apiKey: appConfig.filter.defaultOrderByQueryName, defaultValue: null },
    search: { key: 'fleet_sizes_search', apiKey: appConfig.filter.defaultSearchQueryName, defaultValue: null },
};
